import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import { inject } from '@angular/core';
import { getBrowserLang, Translation, TranslocoService } from '@jsverse/transloco';
import { firstValueFrom } from 'rxjs';

/**
 * Initialize translations for the application.
 * It will set the active language based on browser environment.
 * @param {TranslocoService} transloco - The Transloco service for handling translations
 * @returns {() => Promise<Translation>} - A function returning a Promise that resolves when the active language is set and loaded.
 */
export async function initializeTranslations(): Promise<void | Translation> {
  const transloco = inject(TranslocoService);
  const availableLanguages = transloco.getAvailableLangs().map((x) => (typeof x === 'string' ? x : x.id));
  let activeLanguage: string;

  activeLanguage = getBrowserLang() || 'de';
  activeLanguage = availableLanguages.includes(activeLanguage) ? activeLanguage : 'de';
  transloco.setActiveLang(activeLanguage);

  // Load and register locale data for date pipes and so on..
  loadLocaleData(activeLanguage);

  return await firstValueFrom(transloco.load(activeLanguage)).catch((error) => {
    console.error('Failed to load translations:', error);
  });
}

function loadLocaleData(locale: string) {
  switch (locale) {
    case 'de':
      registerLocaleData(localeDe);
      break;
    case 'en':
      registerLocaleData(localeEn);
      break;
    // Add cases as needed for other languages
  }
}
